import PubSub from "underpub-js";

var ContainerPressReleases = function(options) {

	this.options = {
		$el: false,
		baseClass: 'layout-ContainerPressReleases',
	};

	$.extend(true, this.options, options);

};

ContainerPressReleases.prototype.init = function() {

	var self = this;

};

export default ContainerPressReleases;
